import React from "react";

import { renderDonorDetails } from "widgets/Donation/components/Details/renderDonorDetails";

export const createDetails = (donationFormData, i, formProps, handlers, donationFormContext) => (
  <>
    {
        renderDonorDetails(donationFormData, formProps, handlers, donationFormContext)
      }
  </>
);
